import * as HttpService from "../../../../service/HttpService";
/**
 * 获取屏柜
 */
 export const getCeContainerResonse = () => {
    return HttpService.get(HttpService.DOMAIN + "/BigScreenEnergyConsume/getCeContainerResonse");
};
/* 
*获取屏柜下的表计
*/

export const getMeterUnderCabinet = (params) => {
    return HttpService.getNormal(HttpService.DOMAIN + "/yongnengbaoAPP/getMeterUnderCabinet",params);
};
/**
 * 查询用能报表
 */
 export const getEnergyConsumptionReport = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/BigScreenEnergyConsume/getEnergyConsumptionReport",data);
};
